<template>
  <v-container fluid ma-0 pa-0>
    <v-row no-gutters>
      <v-col>
        <v-stepper v-model="step" non-linear>
          <v-stepper-header>
            <v-stepper-step
            editable
      :complete="step > 1"
      step="1"
      edit-icon="done"
    >
      Order
    </v-stepper-step>

            <v-divider></v-divider>
<!-- <v-stepper-step
            editable
      :complete="step > 0"
      step="0"
      v-if="false"
    >
      To Collect
</v-stepper-step> -->

            <v-divider></v-divider>
<v-stepper-step
            :editable="itemId != 0"
      :complete="step > 2"
      step="2"
      edit-icon="done"
    >
      Collected Item
</v-stepper-step>

            <v-divider></v-divider>

<v-stepper-step
            :editable="status != 'NONE' && status != 'ORDER'"
      :complete="step > 3"
      step="3"
      edit-icon="done"
    >
      Assign
</v-stepper-step>

            <v-divider></v-divider>
<v-stepper-step
            :editable="status != 'NONE' && status != 'COLLECTED' && status != 'ORDER' "
      :complete="step > 4"
      step="4"
      edit-icon="done"
      icon="looks_4"
    >Payment</v-stepper-step>

            <v-divider></v-divider>

            <!-- <v-stepper-step
              :editable="status != 'NONE'"
              edit-icon="done"
              :complete="step > 5"
              step="5"
            >Car Gate</v-stepper-step> -->
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <order
                :itemId="itemId"
                :loadOrder="loadOrder"
                :saveOrder="saveOrder"
                :updateOrder="updateOrder"
                :order.sync="order"
              />
            </v-stepper-content>

            <!-- <v-stepper-content step="2" hidden>
              <collect
                ref="collect"
                :itemId="itemId"
                :loadCollect="loadCollect"
                :saveCollect="saveCollect"
                :updateCollect="updateCollect"
                :collect.sync="collect"
              />
            </v-stepper-content> -->

            <v-stepper-content step="2">
              <collected-item-detail
                :itemId="itemId"
                :loadCollectedItem="loadCollectedItem"
                :saveCollectedItem="saveCollectedItem"
                :updateCollectedItem="updateCollectedItem"
                :collectedItem.sync="collectedItem"
                :status="status"
                ref="collected"
              />
            </v-stepper-content>
            <v-stepper-content step="3">
              <assign
                ref="assign"
                :itemId="itemId"
                :assign="assign"
                :loadAssign="loadAssign"
                :saveAssign="saveAssign"
                :updateAssign="updateAssign"
                :onOffRider="onOffRider"
              />
            </v-stepper-content>
            <v-stepper-content step="4">
              <payment
                ref="payment"
                :itemId="itemId"
                :payment="payment"
                :status="status"
                :loadPayment="loadPayment"
                :updatePayment="updatePayment"
              />
            </v-stepper-content>
            <!-- <v-stepper-content step="5">
              <car-gate
                ref="carGate"
                :itemId="itemId"
                :carGate="carGate"
                :status="status"
                :loadGate="loadGate"
                :saveGate="beforeSaveGate"
                :updateGate="beforeUpdateGate"
              />
            </v-stepper-content> -->
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Order from "../components/Order";
import Collect from "../components/Collect";
import CollectedItemDetail from "../components/CollectedItemDetail";
import CarGate from "@/components/CarGate";
import Payment from "../components/Payment";
import Assign from "../components/Assign";
import orderService from "../service/OrderService";
import collectService from "../service/CollectService";
import assignService from "../service/AssignService";
import paymentService from "../service/PaymentService";
import carGateService from "../service/CarGateService";

export default {
  beforeMount: function () {
    let itemId = this.$route.query.itemId;
    if (itemId == undefined || itemId == "") {
      this.itemId = 0;
    } else {
      this.itemId = Number(itemId);
    }

    this.reloadStatus();
  },
  data() {
    return {
      loadIndex:0,
      onOffRider:0,
      order: {
        itemId: 0,
        fromBranchDto: {
          branchId: 0,
        },
        toBranchDto: {
          branchId: 0,
        },
        osDto: {
          osId: 0,
        },
        townshipDto: {
          townshipId: 0,
        },
        requestDate: "",
        orderRemark: "",
        date: "",
        modifiedDate: "",
      },
      collect: {
        itemId: 0,
        collectId: 0,
        employeeDto: {
          userAccountId: 0,
        },
        remark: "",
        date: "",
        modifiedDate: "",
      },
      collectedItem: {
        itemId: 0,
        itemName: " ",
        weight: "",
        osPayment: false,
        customerPayment: false,
        advancePaid: 0,
        remark: "",
        transactionId: 0,
        amount: 0,
        itemValue: 0,
        fromOSId: 0,
        collectDate: "",
        date: "",
        modifiedDate: "",
        customerName: "",
        address: "",
        phone: "",
        code: "",
        paid: 0,
      },
      assign: {
        itemId: 0,
        assignId: 0,
        employeeDto: {
          userAccountId: 0,
        },
        remark: "",
        date: "",
        modifiedDate: "",
      },
      payment: {
        transactionId: 0,
        osId: 0,
        itemId: 0,
        itemValue: 0,
        amount: 0,
        customerPaid: 0,
        payment: 0,
        balance: 0,
        assignDate: "",
        date: "",
        modifiedDate: "",
        remark: "",
      },
      carGate: {
        gateId: 0,
        transactionId: 0,
        amount: 0,
        receive: 0,
        balance: 0,
        gateRemark: "",
        date: "",
        modifiedDate: "",
      },
      itemId: 0,
      status: "NONE",
      indexLoad:0
    };
  },
  components: {
    order: Order,
    collect: Collect,
    "collected-item-detail": CollectedItemDetail,
    assign: Assign,
    payment: Payment,
    "car-gate": CarGate,
  },
  methods: {
    reloadStatus: function () {
      if (this.itemId != 0)
        orderService.getStatus(this.itemId).then((data) => {
          this.status = data;

          let step = this.$route.query.step;

          if (step == undefined || step == "") {
            this.step = 0;
          } else {
            if ((step == 2) && this.itemId != 0) {
              this.step = Number(2);
            } else if (
              (step == 3 || step == 5) &&
              this.status != "NONE" &&
              this.itemId != 0
            ) {
              this.step = Number(step);
            } else if (step == 4 && status != "NONE" && status != "COLLECTED") {
              this.step = Number(step);
            } else {
              this.step = 1;
            }
          }
        });
    },
    // start order component
    loadOrder: function () {
      if(this.loadIndex!=1){
      orderService.loadOrder(this.itemId).then((data) => {
        this.order = data;
        this.loadIndex = 1;
      });
      }else{
        this.loadIndex = 0;
      }
    },
    saveOrder: function () {
      orderService.saveOrderService(this.order).then((data) => {
        this.order = data;
        this.itemId = this.order.itemId;
        this.$router
          .replace({
            name: "manage-order",
            query: { itemId: this.itemId, step: 2 },
          })
          .catch(() => {});
        this.reloadStatus();
        this.changeStep(2);//2
      });
    },
    updateOrder: function () {
      orderService.updateOrderService(this.itemId, this.order).then((data) => {
        this.order = data;
        //this.loadCollectedItem(1);
        this.changeStep(2);//2
      });
    },
    // end order component
    // start collect component
    loadCollect: function () {
      collectService.getCollectByItemId(this.itemId).then((data) => {
        this.collect = data;
      });
    },
    saveCollect: function () {
      collectService.saveCollect(this.itemId, this.collect).then((data) => {
        this.collect = data;
        this.reloadStatus();
        this.$router
          .replace({
            name: "manage-order",
            query: { itemId: this.itemId, step: 3 },
          })
          .catch(() => {});
      });
    },
    updateCollect: function () {
      // collectService
      //   .updateCollect(this.itemId, this.collect.collectId, this.collect)
      //   .then((data) => {
      //     this.collect = data;
      //     this.changeStep(3);
      //   });
      this.changeStep(2);
    },
    // end collect component
    // start collected Item Detail component
    loadCollectedItem: function (value) {
      //if(this.indexLoad==0 || value == 1){
      collectService
        .getCollectedItemDetailByItemId(this.itemId)
        .then((data) => {
          this.indexLoad = 1;
          this.collectedItem = data;
          
        });
      //}
    },
    saveCollectedItem: function (print = false) {
      collectService
        .saveCollectedItemDetail(this.itemId, this.collectedItem)
        .then((data) => {
          this.collectedItem = data;
          if (print) {
            this.$refs.collected.printPreview();
          } else {
            this.reloadStatus();
            this.changeStep(3);
          }
        })
        .catch((error) => {
          this.$swal(error.error, error.message, "error");
        });
    },
    updateCollectedItem: function (print = false) {
      collectService
        .updateCollectedItemDetail(
          this.itemId,
          this.collectedItem.transactionId,
          this.collectedItem
        )
        .then((data) => {
          this.loadOrder();
          this.collectedItem = data;
          if (print) {
            this.$refs.collected.printPreview();
          } else {
            this.changeStep(3);
          }
        })
        .catch((error) => {
          this.$swal(
            error.response.data.error,
            error.response.data.message,
            "error"
          );
        });
    },
    //end collected Item Detail component
    //start assign component
    loadAssign: function () {
      assignService.getAssignByItemId(this.itemId).then((data) => {
        this.assign = data;
      });
    },
    saveAssign: function () {
      assignService.saveAssign(this.itemId, this.assign).then((data) => {
        this.assign = data;
        this.reloadStatus();
        this.changeStep(4);
        this.onOffRider = 0;
      }).catch((error) => {
              //this.$swal("Failed", error.response.data.message, "error");
              this.onOffRider = 1;
            });
    },
    updateAssign: function () {
      assignService
        .updateAssign(this.itemId, this.assign.assignId, this.assign)
        .then((data) => {
          this.assign = data;
          this.changeStep(4);
          this.onOffRider = 0;
        }).catch((error) => {
              //this.$swal("Failed", error.response.data.message, "error");
              this.onOffRider = 1;
            });
    },
    //end assign component
    loadPayment: function () {
      paymentService.getPaymentByItemId(this.itemId).then((data) => {
        this.payment = data;
        this.$set(this.payment, "itemStatus", this.status);
      });

    },
    updatePayment: function () {
      paymentService
        .updatePayment(this.itemId, this.payment.transactionId, this.payment)
        .then((data) => {
          this.payment = data;
          this.reloadStatus();
          //this.changeStep(6);
          //this.$swal("Successfule", "SAVE, Customer Payment", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Customer Payment",
     type: "success",
     timer: 500
     });

        });
    },
    changeStep: function (value) {
      this.step = value;
    },
    beforeSaveGate: function (value) {
      carGateService.saveCarGate(this.itemId, value).then((data) => {
        this.carGate = data;
        //this.$swal("Successfule", "SAVE, Car Gate", "success");
        this.$swal({
     title: "Successful",
     text: "SAVE, Car Gate",
     type: "success",
     timer: 500
     });
      });
    },
    beforeUpdateGate: function (value) {
      carGateService
        .updateCarGate(this.itemId, value.gateId, value)
        .then((data) => {
          this.carGate = data;
          //this.$swal("Successfule", "SAVE, Car Gate", "success");
          this.$swal({
     title: "Successful",
     text: "SAVE, Car Gate!",
     type: "success",
     timer: 500
     });
        });
    },
    loadGate: function () {
      carGateService.getCarGateByItemId(this.itemId).then((data) => {
        this.carGate = data;
      });
    },
  },
  computed: {
    step: {
      set(value) {
        let step = this.$route.query.step;
        this.$router
          .replace({
            name: "manage-order",
            query: {
              itemId: this.itemId,
              step: value,
            },
          })
          .catch(() => {});
      },
      get() {
        let step = this.$route.query.step;

        if (step == undefined || step == "") {
          return 0;
        } else {
          if (step == 3) {
            if (this.$refs.assign != undefined) {
              this.$refs.assign.getAllDeliveryForAssign();
            }
          } 
          // else if (step == 2) {
          //   if (this.$refs.collect != undefined) {
          //     this.$refs.collect.getAllDeliveryForCollect();
          //   }
          // } 
          else if (step == 4) {
            if (this.$refs.payment != undefined) {
              //this.$refs.payment.loadPayment
              this.loadPayment();
            }
          } else if (step == 2) {
            this.loadCollectedItem();
          }
          return step;
        }
      },
    },
  },
  watch: {
    "$route.query.itemId": function (newVal, oldVal) {
      if (oldVal) {
        if (!newVal) {
          this.itemId = 0;
          this.step = 1;
          this.order = {
            itemId: 0,
            fromBranchDto: {
              branchId: 0,
            },
            toBranchDto: {
              branchId: 0,
            },
            osDto: {
              osId: 0,
            },
            townshipDto: {
              townshipId: 0,
            },
            customerName: "",
            address: "",
            phone: "",
            code: "",
            requestDate: "",
            date: "",
            modifiedDate: "",
          };
          this.collect = {
            itemId: 0,
            collectId: 0,
            employeeDto: {
              userAccountId: 0,
            },
            remark: "",
            date: "",
            modifiedDate: "",
          };
          this.collectedItem = {
            itemId: 0,
            encryptedCode: "",
            itemName: "",
            weight: "",
            osPayment: false,
            customerPayment: false,
            advancePaid: 0,
            remark: "",
            transactionId: 0,
            amount: 0,
            itemValue: 0,
            fromOSId: 0,
            collectDate: "",
            date: "",
            modifiedDate: "",
          };
          this.assign = {
            itemId: 0,
            assignId: 0,
            employeeDto: {
              userAccountId: 0,
            },
            remark: "",
            date: "",
            modifiedDate: "",
          };
          this.$router
            .replace({
              name: "manage-order",
              query: {
                itemId: this.itemId,
                step: this.step,
              },
            })
            .catch(() => {});
        }
      }
      
      this.loadOrder();
    },
  },
};
</script>
<style scoped>
.v-stepper__content {
padding: 2px !important;
}
</style>